import { SessionStorageManager } from './localStorage'
import { PAYMENT_TYPE_CODE } from '../constants/global'

const PAYMENT_THEME_NAME_STORAGE_KEY = 'paymentThemeName'
const DEFAULT_API_URL = process.env.REACT_APP_API_URL || 'https://cdn-dev.kiemdinhoto.vn'
const TTDK_API_URL = process.env.REACT_APP_API_URL_TTDK || DEFAULT_API_URL
const TAMOVE_API_URL = process.env.REACT_APP_API_URL_TAMOVE || DEFAULT_API_URL
const THEME_NAME_TTDK = 'ttdk'
const THEME_NAME_TAMOVE = 'tamove'

const getResolvedPaymentThemeName = (envPaymentThemeName) => {
  try {
    const themeNameFromSessionStorage = SessionStorageManager.getItem(PAYMENT_THEME_NAME_STORAGE_KEY)
    if (
      themeNameFromSessionStorage !== undefined &&
      themeNameFromSessionStorage !== null &&
      themeNameFromSessionStorage !== ''
    ) {
      return String(themeNameFromSessionStorage)
    }
  } catch (error) {
    return envPaymentThemeName || undefined
  }

  return envPaymentThemeName || undefined
}

export const resolveApiHost = ({ defaultApiUrl, themeApiUrl, targetThemeName, envThemeName }) => {
  const resolvedThemeName = getResolvedPaymentThemeName(envThemeName)
  const normalizedThemeName = String(resolvedThemeName || '').trim().toLowerCase()
  const normalizedTargetThemeName = String(targetThemeName || '').trim().toLowerCase()

  return normalizedThemeName === normalizedTargetThemeName ? themeApiUrl : defaultApiUrl
}

export const getApiHost = () => {
  const resolvedThemeName = getResolvedPaymentThemeName(process.env.REACT_APP_PAYMENT_THEME_NAME)
  const normalizedThemeName = String(resolvedThemeName || '').trim().toLowerCase()

  return resolveApiHost({
    defaultApiUrl: DEFAULT_API_URL,
    themeApiUrl: normalizedThemeName === THEME_NAME_TAMOVE ? TAMOVE_API_URL : TTDK_API_URL,
    targetThemeName: normalizedThemeName === THEME_NAME_TAMOVE ? THEME_NAME_TAMOVE : THEME_NAME_TTDK,
    envThemeName: resolvedThemeName
  })
}

export const normalizePaymentMethodCode = (value) => {
  const normalized = String(value || '').trim().toUpperCase()
  if (!normalized) return undefined

  const paymentTypeCodes = Object.values(PAYMENT_TYPE_CODE || {})
  const compact = normalized.replace(/_/g, '')
  const directMatched = paymentTypeCodes.find((code) => code === normalized)
  if (directMatched) return directMatched

  const compactMatched = paymentTypeCodes.find((code) => String(code || '').replace(/_/g, '') === compact)
  return compactMatched || undefined
}
